import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Button, Text } from '@/ui';
import { Icon } from '@/ui/icon';
import { ArrowRight } from '@/ui/icons';

interface ListItemStatusProps {
  icon: React.ReactNode;
  text: string;
  subtext?: React.ReactNode;
  buttonText?: string;
  onPress?: () => void;
}

export default function ListItemStatus({
  icon,
  text,
  subtext,
  buttonText,
  onPress,
}: ListItemStatusProps) {
  const { styles, theme } = useStyles(stylesheet);

  return (
    <View style={styles.container}>
      <View
        style={{
          gap: 8,
          flexDirection: 'row',
          alignItems: 'center',
          flex: 1,
        }}
      >
        <View style={{}}>{icon}</View>

        <View style={{ flex: 1 }}>
          <Text type="bodyRegular">{text}</Text>

          {subtext}
        </View>
      </View>

      {buttonText ? (
        <Button
          text={buttonText}
          type="primaryExtraSmall"
          onPress={() => {
            onPress?.();
          }}
          rightIcon={
            <Icon
              type="naked"
              icon={<ArrowRight />}
              fillColor={theme.colors.button.primary.default.text}
              width={10}
              height={10}
            />
          }
          style={{
            minWidth: 80,
          }}
        />
      ) : null}
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));
